'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultFormatter;
function defaultFormatter(value, unit, suffix) {
  if (value !== 1) {
    unit += 's';
  }
  return value + ' ' + unit + ' ' + suffix;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-timeago/lib/defaultFormatter.js
// module id = 224
// module chunks = 0